import styled from "styled-components";

export const ExpandableHeaderRoot = styled.div`
    padding: 10px;
`;
